import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";

import { faSave } from "@fortawesome/free-solid-svg-icons";

import { ListarDocumentoTemplateController } from "../../../../Controllers/Geral/Documentos/DocumentosController";
import {
    ExportarDocumentoHtmlParaPdfController,
    GerarDocumentosTemplateController,
} from "../../../../Controllers/Geral/Email/EmailController";

import { useHistoricoContext } from "../../../../Context/Historico";

import "./styles.css";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import UnForm from "../../../../Components/Form";
import { saveAs } from "file-saver";
import { FroalaEditor } from "../../../../Components/CardsPages/Forms/Editor/FroalaEditor";
import SpinnerComponent from "../../../../Components/Loding/Spinner";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { AlertConfirmation } from "../../../../Tools/SweetAlerts";
import { useUserInfor } from "../../../../Context/User";

interface htmlQuill {
    editorHtml: string;
}

interface IModalGerarPdfEmailProps {
    ID_CONTA: number;
    ID_CASO: number;
    ID_CONTATO: number;
    setShow: (show: boolean) => void;
}

interface PropsFormData extends htmlQuill {
    idDocumentoTemplate: number;
}

export function ModalGerarPdfEmail(props: IModalGerarPdfEmailProps) {
    const { ID_CASO, idModulo, Atendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();
    const { formState, setValue } = useForm();
    const [convertedText, setConvertedText] = useState<htmlQuill>(
        {} as htmlQuill
    );

    const { Config } = useUserInfor();

    const [valueTemplateEmail, setValueTemplateEmail] = useState<string>();

    // const [uploading, setUploading] = useState(false);
    // const [uploadedImages, setUploadedImages] = useState<string[]>([]);

    const {
        value: LstDocumentoTemplate,
        loading: LstDocumentoTemplateLoading,
    } = useAsyncEffect(() =>
        ListarDocumentoTemplateController({
            idTipoCaso: idModulo,
            ...(Config.FL_LISTA_TEMPLATE_PRODUTO && {
                idProduto: Atendimento?.ID_EMPREENDIMENTO,
            }),
        })
    );

    const {
        execute: exportarDocumentoParaHtml,
        loading: exportarDocumentoParaHtmlLoading,
    } = useAsyncCallback(ExportarDocumentoHtmlParaPdfController);

    const handleSubmiGerarPDF: SubmitHandler<PropsFormData> = (
        formData,
        event
    ) => {
        const formEvent = event?.nativeEvent as SubmitEvent;
        const buttonElement = formEvent?.submitter as HTMLButtonElement;
        if (buttonElement?.name === "gerarPdf") {
            exportarDocumentoParaHtml({
                FL_GERAR_PDF: true,
                ID_DOCUMENTO_TEMPLATE: Number(formData.idDocumentoTemplate)
                    ? Number(formData.idDocumentoTemplate)
                    : 0,
                strHTML: convertedText.editorHtml,
                ID_CASO: ID_CASO,
            }).then((res) => {
                saveAs(res, valueTemplateEmail);
                ReloadHistorico();
                props.setShow(false);
            });
        } else if (buttonElement?.name === "salvarContrato") {
            exportarDocumentoParaHtml({
                FL_GERAR_PDF: false,
                ID_DOCUMENTO_TEMPLATE: formData.idDocumentoTemplate,
                strHTML: convertedText.editorHtml,
                ID_CASO: ID_CASO,
            }).then(() => {
                ReloadHistorico();
                props.setShow(false);
                AlertConfirmation(
                    "Inserido com Sucesso",
                    undefined,
                    undefined,
                    { confirmButtonText: false, cancelButtonText: false }
                );
            });
        }
    };

    const {
        execute: gerarDocumentosTemplate,
        loading: gerarDocumentosTemplateLoading,
    } = useAsyncCallback(GerarDocumentosTemplateController);

    function handleChange(html: string) {
        setConvertedText({ editorHtml: html });
    }

    return (
        <UnForm
            handleSubmit={handleSubmiGerarPDF}
            className="w-100 align-itens-center mt-5"
        >
            <div className="row mb-3 d-flex flex-wrap">
                <div className="col-12 col-lg-6 mt-2">
                    <label>Template de Email:</label>
                    {!LstDocumentoTemplateLoading ? (
                        <>
                            <UnForm.Select
                                registerOptions={{
                                    required: "Escolha um template de email",
                                }}
                                name="idDocumentoTemplate"
                                className={`form-control placeholder-dark-50  ${
                                    formState.errors.ID_MODELO_EMAIL &&
                                    "is-invalid"
                                }`}
                                onChange={(e) => {
                                    const selectedOptionText =
                                        e.target.options[e.target.selectedIndex]
                                            .text;

                                    setValueTemplateEmail(selectedOptionText);

                                    const idTemplateEmail = Number.parseInt(
                                        e.target.value
                                    );
                                    if (e && idTemplateEmail) {
                                        const docTemplate =
                                            LstDocumentoTemplate?.find(
                                                (dt) =>
                                                    dt.ID_DOCUMENTO_TEMPLATE ===
                                                    idTemplateEmail
                                            );
                                        if (
                                            docTemplate &&
                                            docTemplate.DS_ASSUNTO
                                        )
                                            setValue(
                                                "assunto",
                                                docTemplate.DS_ASSUNTO
                                            );
                                        setConvertedText({
                                            editorHtml: "Carregando....",
                                        });
                                        gerarDocumentosTemplate(
                                            idTemplateEmail,
                                            props.ID_CASO
                                        )
                                            .then((res) => {
                                                setConvertedText({
                                                    editorHtml: res,
                                                });
                                            })
                                            .catch(() => {
                                                setConvertedText({
                                                    editorHtml:
                                                        "Erro ao carregar template.",
                                                });
                                            });
                                    }
                                }}
                            >
                                <option value={0}>Modelo de email</option>
                                {LstDocumentoTemplate &&
                                    LstDocumentoTemplate.map((doc) => {
                                        return (
                                            <option
                                                key={doc.ID_DOCUMENTO_TEMPLATE}
                                                value={
                                                    doc.ID_DOCUMENTO_TEMPLATE
                                                }
                                            >
                                                {doc.DS_DOCUMENTO}
                                            </option>
                                        );
                                    })}
                            </UnForm.Select>
                        </>
                    ) : (
                        <SpinnerComponent />
                    )}
                </div>
            </div>
            <div className="row mb-3 d-flex flex-wrap">
                <div className=" w-100 h-100 p-4">
                    {/* {uploading && (
                            <div className="d-flex align-items-center justify-content-center g-2 p-2">
                                Fazendo upload de imagem{" "}
                                <Spinner size="sm" color="primary" />
                            </div>
                        )} */}

                    <FroalaEditor
                        value={convertedText.editorHtml || ""}
                        onChange={handleChange}
                        onImageUploadStart={() => false}
                        onImageUploadEnd={() => false}
                    />
                </div>
            </div>

            <div className="row mb-3 flex-wrap d-flex align-items-center flex-column m-0">
                <UnForm.SubmitButton
                    name="gerarPdf"
                    noDiv={true}
                    className="btn btn-outline-primary font-weight-bold d-flex col-4 justify-content-center mb-3"
                    icon={faSave}
                    color="primary"
                    disabled={
                        exportarDocumentoParaHtmlLoading ||
                        !convertedText.editorHtml ||
                        gerarDocumentosTemplateLoading
                    }
                >
                    Gerar PDF
                </UnForm.SubmitButton>

                <button
                    name="salvarContrato"
                    className="font-weight-bold d-flex col-4 justify-content-center mb-5"
                    formAction={"salvarContrato"}
                    type="submit"
                    style={
                        exportarDocumentoParaHtmlLoading ||
                        !convertedText.editorHtml ||
                        gerarDocumentosTemplateLoading
                            ? {
                                  border: "none",
                                  background: "none",
                                  textDecoration: "underline",
                                  color: "lightGrey",
                              }
                            : {
                                  border: "none",
                                  background: "none",
                                  textDecoration: "underline",
                                  color: "#3699FF",
                              }
                    }
                    color="primary"
                    disabled={
                        exportarDocumentoParaHtmlLoading ||
                        !convertedText.editorHtml ||
                        gerarDocumentosTemplateLoading
                    }
                >
                    Apenas Salvar
                </button>
            </div>
        </UnForm>
    );
}
